import { render, staticRenderFns } from "./emailverification.vue?vue&type=template&id=1e4ef9a6&scoped=true"
import script from "./emailverification.vue?vue&type=script&lang=js"
export * from "./emailverification.vue?vue&type=script&lang=js"
import style0 from "./emailverification.vue?vue&type=style&index=0&id=1e4ef9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ef9a6",
  null
  
)

export default component.exports